const getUMK = (axiosInstance) => {
  return axiosInstance
    .get("umk/")
    .then((res) => res.data)
    .catch(console.error());
};

export default getUMK;
